// @ts-ignore
import { Service, IService } from './../models/service.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { ProductType } from '../models/productType.model';

@Injectable({
  providedIn: 'root'
})

export class ServiceService {

  constructor(private http: HttpClient) { }


  getService(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + sessionStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/service/connected` +
      (size ? '?page=' + page + '&size=' + size : ''), { 'headers': headers });
  }
  getPublishService(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + sessionStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/service/allPosted/`, { 'headers': headers });
  }
  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/service` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getServiceBycurrentSearch(search: string, page: number, size: number) {
    return this.http.get<any>(`${environment.url}/service` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size));
  }

  saveService(Service: IService) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + sessionStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/service`, Service, { 'headers': headers });
  }

  getIdService(idA: number) {
    return this.http.get(`${environment.url}/service/` + idA);
  }

  getIdServiceByShop(idS: any) {
    return this.http.get(`${environment.url}/service/ByShop/` + idS);
  }

  updateService(Service: IService) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.put<any>(`${environment.url}/service/` + Service.id, Service, { 'headers': headers });
  }

  deleteService(service: IService) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + sessionStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/service/` + service.id, { 'headers': headers });
  }

  // api/service/ByShop/{shop_id}
  getServiceByShop(shopId: number): Observable<any> {
    //api/product/productID/{productID}
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/service/ByShop/` + shopId, { 'headers': headers });
  }

  getServiceByShopPaged(idShop: number, page: number, size: number): Observable<any> {
    let headers = new HttpHeaders().set('kapo_session_id', localStorage.getItem('kapo_session_id') || '');
    return this.http.get<any>(`${environment.url}/service/byShopPaged/${idShop}${size ? '?page=' + page + '&size=' + size : ''}`, { headers });
  }

  getKahpooShopsServiceByDate(shop_id: number, startDate: any, endDate: any, page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/service/allshopservices?shop_id=${shop_id}&startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`);
  }

  updateSubCategoryService(productTypeList: ProductType[], idCategorieB: number): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.put<any>(`${environment.url}/product_type/move/service?idProductType=${idCategorieB}`,
      productTypeList, { headers });
  }
}
